'use client';

import { Separator as SeparatorPrimitive } from '@base-ui/react/separator';
import { cn } from '@savvy-kit/lib/utils';

function Separator({
  className,
  orientation = 'horizontal',
  'aria-hidden': ariaHidden = true,
  ...props
}: SeparatorPrimitive.Props) {
  return (
    <SeparatorPrimitive
      data-slot="separator"
      orientation={orientation}
      aria-hidden={ariaHidden}
      className={cn(
        'bg-border shrink-0',
        orientation === 'horizontal' && 'h-px w-full',
        orientation === 'vertical' && 'h-auto self-stretch w-px',
        className,
      )}
      {...props}
    />
  );
}

export { Separator };
